var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 31,
    viewBox: "0 0 62 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2896 13.3013C61.2889 13.3006 61.2883 13.2997 61.2875 13.299L48.6327 0.705242C47.6846 -0.238199 46.1512 -0.234688 45.2075 0.713475C44.264 1.66152 44.2676 3.19493 45.2157 4.13849L53.7121 12.5937H2.42187C1.08427 12.5937 0 13.678 0 15.0156C0 16.3532 1.08427 17.4375 2.42187 17.4375H53.712L45.2158 25.8927C44.2677 26.8363 44.2641 28.3697 45.2077 29.3177C46.1513 30.266 47.6849 30.2693 48.6328 29.326L61.2876 16.7322C61.2883 16.7315 61.2889 16.7307 61.2898 16.7299C62.2383 15.7832 62.2353 14.2448 61.2896 13.3013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.726d9644a0b6705a7199a322712c154d.svg";
export { ForwardRef as ReactComponent };